export const education = {
  "en-US": [
    {
      degree: "Postgraduate (Lato Sensu)",
      title: "Software Architecture",
      period: "08/2023 - 06/2024",
      institution: "Infnet Institute, Rio de Janeiro/RJ",
    },
    {
      degree: "Bachelor of Science",
      title: "Information Systems",
      period: "01/2004 - 06/2011",
      institution: "Estácio de Sá University, Petrópolis/RJ",
    },
  ],

  "pt-BR": [
    {
      degree: "Pós-graduação (Lato Sensu)",
      title: "Arquitetura de Software",
      period: "08/2023 - 06/2024",
      institution: "Instituto Infnet, Rio de Janeiro/RJ",
    },
    {
      degree: "Bacharelado",
      title: "Sistemas de Informação",
      period: "01/2004 - 06/2011",
      institution: "Universidade Estácio de Sá, Petrópolis/RJ",
    },
  ],

  "es-ES": [
    {
      degree: "Posgrado (Lato Sensu)",
      title: "Arquitectura de Software",
      period: "08/2023 - 06/2024",
      institution: "Instituto Infnet, Río de Janeiro/RJ",
    },
    {
      degree: "Licenciatura",
      title: "Sistemas de Información",
      period: "01/2004 - 06/2011",
      institution: "Universidad Estácio de Sá, Petrópolis/RJ",
    },
  ],
};
